// Mock data for Alquiler Adelantado landing page

export const heroData = {
  title: "Ahorra hasta un 30% en tu alquiler con nuestros planes flexibles",
  subtitle: "Te encontramos el arrendador o inquilino ideal. Planes de 2, 3 o 5 años con descuentos progresivos. Firmamos contrato presencial y tú solo pagas si hay acuerdo.",
  heroImage: "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcGFydG1lbnR8ZW58MHx8fHwxNzU0NTg0NDY2fDA&ixlib=rb-4.1.0&q=85",
  ctaText: "Solicita contacto"
};

export const pricingPlans = [
  { years: 2, discount: 20, title: "Plan Estándar", description: "Ideal para empezar" },
  { years: 3, discount: 25, title: "Plan Ventaja", description: "Mayor ahorro y estabilidad" },
  { years: 5, discount: 30, title: "Plan Máximo", description: "El mejor descuento disponible" }
];

export const howItWorksData = [
  {
    step: 1,
    title: "Nos cuentas qué necesitas",
    description: "Completas nuestro formulario con tus preferencias, zona deseada y plan de años preferido.",
    icon: "MessageSquare"
  },
  {
    step: 2,
    title: "Buscamos al perfil ideal con tu condición",
    description: "Utilizamos nuestro filtro avanzado para encontrar la coincidencia perfecta según tu plan elegido.",
    icon: "Search"
  },
  {
    step: 3,
    title: "Firmamos y tú ahorras — nosotros solo cobramos si hay trato",
    description: "Coordinamos la firma del contrato con el descuento acordado y solo cobramos si hay acuerdo exitoso.",
    icon: "CheckCircle"
  }
];

export const ownerBenefits = [
  {
    title: "Liquidez inmediata",
    description: "Recibe el dinero del alquiler por adelantado (2, 3 o 5 años según el plan acordado)",
    icon: "Banknote"
  },
  {
    title: "Sin riesgo de impagos",
    description: "Olvídate de las preocupaciones por morosidad o inquilinos problemáticos durante todo el período",
    icon: "Shield"
  },
  {
    title: "Contrato blindado",
    description: "Contratos legalmente sólidos que protegen tus intereses por toda la duración del plan",
    icon: "FileText"
  },
  {
    title: "Sin gestión mensual",
    description: "No necesitas gestionar cobros ni mantenimiento durante el período contratado",
    icon: "Calendar"
  }
];

export const tenantBenefits = [
  {
    title: "Descuentos progresivos",
    description: "20% en 2 años, 25% en 3 años, o 30% en 5 años - tú eliges tu ahorro",
    icon: "PiggyBank"
  },
  {
    title: "Cero preocupaciones",
    description: "Estabilidad total durante todo el período sin aumentos ni sorpresas",
    icon: "Heart"
  },
  {
    title: "Ideal para personas con liquidez",
    description: "Perfecto para autónomos, expatriados e inversores que buscan estabilidad",
    icon: "TrendingUp"
  },
  {
    title: "Proceso simplificado",
    description: "Evita largos procesos de búsqueda y negociación cada pocos años",
    icon: "Zap"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "María González",
    role: "Propietaria",
    image: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcGFydG1lbnR8ZW58MHx8fHwxNzU0NTg0NDY2fDA&ixlib=rb-4.1.0&q=85",
    testimonial: "Opté por el plan de 3 años y conseguí toda la liquidez que necesitaba sin preocuparme por impagos. El proceso fue transparente y profesional.",
    location: "Madrid"
  },
  {
    id: 2,
    name: "Carlos Ruiz",
    role: "Inquilino",
    image: "https://images.unsplash.com/photo-1664372623516-0b1540d6771e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhcGFydG1lbnR8ZW58MHx8fHwxNzU0NTg0NDY2fDA&ixlib=rb-4.1.0&q=85",
    testimonial: "Con el plan de 2 años ahorré más de 4.800€ en mi alquiler. Como autónomo, tener estabilidad de precio por 2 años es genial.",
    location: "Barcelona"
  },
  {
    id: 3,
    name: "Ana Martín",
    role: "Propietaria",
    image: "https://images.pexels.com/photos/33331096/pexels-photo-33331096.jpeg",
    testimonial: "Elegí el plan de 5 años y el servicio superó mis expectativas. Liquidez inmediata y cero complicaciones durante todo el proceso.",
    location: "Valencia"
  },
  {
    id: 4,
    name: "Roberto Jiménez",
    role: "Inquilino",
    image: "https://images.unsplash.com/photo-1494526585095-c41746248156?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxyZW50YWwlMjBwcm9wZXJ0eXxlbnwwfHx8fDE3NTQ1ODQ0NzJ8MA&ixlib=rb-4.1.0&q=85",
    testimonial: "Como expatriado, el plan de 3 años me dio la tranquilidad que necesitaba. Ahorro del 25% y sin preocupaciones por 3 años completos.",
    location: "Sevilla"
  },
  {
    id: 5,
    name: "Carmen López",
    role: "Propietaria",
    image: "https://images.pexels.com/photos/3125905/pexels-photo-3125905.jpeg",
    testimonial: "Tenía dudas al principio, pero el plan de 2 años me convenció. Recibí todo el dinero por adelantado y sin problemas de gestión.",
    location: "Bilbao"
  },
  {
    id: 6,
    name: "David Torres",
    role: "Inquilino", 
    image: "https://images.pexels.com/photos/2599868/pexels-photo-2599868.jpeg",
    testimonial: "El plan de 5 años era perfecto para mi situación. 30% de descuento durante 5 años, ideal para mi inversión a largo plazo.",
    location: "Málaga"
  }
];

export const legalSecurityData = {
  title: "Seguridad legal garantizada",
  description: "No gestionamos alquileres. No cobramos por adelantado. Solo cobramos si se firma. Con nuestros planes flexibles de 2, 3 o 5 años, todos quedan tranquilos durante todo el período.",
  features: [
    "Contratos supervisados por abogados especializados",
    "Sin comisiones ocultas ni pagos anticipados", 
    "Solo cobramos si hay acuerdo exitoso",
    "Transparencia total en todo el proceso"
  ]
};

export const contactFormFields = [
  { name: "nombre", label: "Nombre completo", type: "text", required: true },
  { name: "telefono", label: "Teléfono", type: "tel", required: true },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "perfil", label: "¿Eres propietario o inquilino?", type: "select", required: true, options: ["Propietario", "Inquilino"] },
  { name: "zona", label: "Zona deseada", type: "text", required: true },
  { name: "comentario", label: "Comentario adicional", type: "textarea", required: false }
];

// Updated business data with corrected email
export const businessData = {
  companyName: "URBAN RUES S.L",
  cif: "B02852192",
  address: "Calle Ávila Nº6 1D, Móstoles, Madrid 28937",
  phone: "+34 684 059 141",
  email: "info@alquileradelantado.com",
  whatsappNumber: "34684059141"
};